var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chips-last-statement"}},[_c('v-chip',{attrs:{"color":_vm.getColor(),"outlined":"","small":""}},[_c('span',{class:`${_vm.getColor()}--text`},[(_vm.date)?[_vm._v(" "+_vm._s(_vm.previous_text)+" "+_vm._s(_vm.moment(_vm.date).fromNow())+" "+_vm._s(_vm.after_text)+" ")]:[_vm._v(" "+_vm._s(_vm.fallback_text)+" ")]],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }